import { useEffect, useState } from "react";
import { Badge, Dropdown, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../../common/DeleteModal";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Translate } from "../../../../Enums/Tranlate";
import editIcon from "../../../../../images/icons/edit.svg";
import trashIcon from "../../../../../images/icons/delete.svg";
import AdminService from "../../../../../services/AdminService";
import { usePermissions } from "../../../../common/permissions";

const CardItem = ({ item, index, setShouldUpdate, setItem, setAddModal }) => {
	const [status, setStatus] = useState(null);
	const [deleteModal, setDeleteModal] = useState(false);
	const navigate = useNavigate();
	const adminService = new AdminService();
	const Auth = useSelector((state) => state.auth?.auth);
	const { canEdit, canDelete } = usePermissions();
	const lang = useSelector((state) => state.auth?.lang);

	useEffect(() => {
		setStatus(!item.isBlocked);
	}, [item]);

	const changeStatusToggle = (e) => {
		let data = {
			isBlocked: status,
		};
		adminService.toggleStatus(item.id, data).then((res) => {
			if (res?.status === 200) {
				toast.success(Translate[lang].updated_status_successfully);
				setStatus(!status);
			}
		});
	};

	return (
		<tr key={index}>
			<td className="text-wrap-mode">{item?.username}</td>
			<td>{item?.phone}</td>
			<td>{item?.email}</td>
			<td>
				<Badge variant="outline-success light">
					{item?.admin_permissions[0]?.admin_role?.name?.toLocaleLowerCase()}
				</Badge>
			</td>
			<td>{item?.license_number || "-"}</td>
			{/* <td>-</td> */}
			<td className="text-wrap-mode">{item?.work_shift?.name}</td>
			<td>
				{!!item?.license_image ? (
					<a href={item?.license_image} target="_blank" rel="noreferrer">
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<path
								d="M18.0751 1.55402L22.2481 5.90402V22.446H6.6593V22.5H22.3013V5.95877L18.0751 1.55402Z"
								fill="#909090"
							/>
							<path
								d="M18.0232 1.5H6.60596V22.446H22.248V5.90475L18.0232 1.5Z"
								fill="#F4F4F4"
							/>
							<path
								d="M6.49123 2.625H1.69873V7.74525H16.7737V2.625H6.49123Z"
								fill="#7A7B7C"
							/>
							<path
								d="M16.854 7.65824H1.79626V2.53424H16.854V7.65824Z"
								fill="#DD2025"
							/>
							<path
								d="M6.78897 3.40051H6.76647H6.61122H5.80872V7.00051H6.57972V5.78626L6.74997 5.79601C6.91539 5.79317 7.07927 5.76353 7.23522 5.70826C7.37194 5.66124 7.49772 5.58699 7.60497 5.49001C7.71409 5.39763 7.80013 5.28103 7.85622 5.14951C7.93144 4.93089 7.95831 4.69854 7.93497 4.46851C7.93028 4.30419 7.90147 4.14145 7.84947 3.98551C7.80212 3.87294 7.73186 3.77146 7.64315 3.68753C7.55444 3.6036 7.44923 3.53906 7.33422 3.49801C7.23477 3.46201 7.13203 3.43589 7.02747 3.42001C6.94829 3.4078 6.86833 3.40128 6.78822 3.40051M6.64647 5.12101H6.57972V4.01101H6.72447C6.78835 4.00641 6.85245 4.01621 6.91204 4.03971C6.97163 4.06321 7.02517 4.09979 7.06872 4.14676C7.15896 4.26752 7.20716 4.41452 7.20597 4.56526C7.20597 4.74976 7.20597 4.91701 7.03947 5.03476C6.91952 5.10074 6.78298 5.13119 6.64647 5.12101Z"
								fill="#464648"
							/>
							<path
								d="M9.39979 3.39077C9.31654 3.39077 9.23554 3.39677 9.17854 3.39902L9.00004 3.40352H8.41504V7.00352H9.10354C9.36666 7.01073 9.62863 6.96613 9.87454 6.87227C10.0725 6.79376 10.2477 6.6672 10.3845 6.50402C10.5176 6.33936 10.613 6.14764 10.6643 5.94227C10.7232 5.70967 10.7519 5.47045 10.7498 5.23052C10.7643 4.94713 10.7424 4.66306 10.6845 4.38527C10.6296 4.18079 10.5268 3.99234 10.3845 3.83552C10.2729 3.70889 10.1363 3.60674 9.98329 3.53552C9.85187 3.4747 9.71364 3.42988 9.57154 3.40202C9.51503 3.39268 9.45781 3.38842 9.40054 3.38927M9.26404 6.34202H9.18904V4.04402H9.19879C9.35341 4.02623 9.50985 4.05413 9.64879 4.12427C9.75054 4.20551 9.83344 4.30787 9.89179 4.42427C9.95476 4.54677 9.99105 4.68122 9.99829 4.81877C10.005 4.98377 9.99829 5.11877 9.99829 5.23052C10.0013 5.35924 9.99306 5.48799 9.97354 5.61527C9.95042 5.74594 9.90769 5.87237 9.84679 5.99027C9.77786 6.09988 9.68472 6.19225 9.57454 6.26027C9.48201 6.32011 9.37243 6.34804 9.26254 6.33977"
								fill="#464648"
							/>
							<path
								d="M13.0725 3.4035H11.25V7.0035H12.021V5.5755H12.996V4.9065H12.021V4.0725H13.071V3.4035"
								fill="#464648"
							/>
							<path
								d="M16.3358 15.1913C16.3358 15.1913 18.7268 14.7578 18.7268 15.5745C18.7268 16.3913 17.2455 16.059 16.3358 15.1913ZM14.568 15.2535C14.1881 15.3374 13.8179 15.4603 13.4633 15.6203L13.7633 14.9453C14.0633 14.2703 14.3745 13.35 14.3745 13.35C14.7325 13.9525 15.149 14.5182 15.618 15.039C15.2643 15.0917 14.9138 15.1639 14.568 15.255V15.2535ZM13.6215 10.3785C13.6215 9.66676 13.8518 9.47251 14.031 9.47251C14.2103 9.47251 14.412 9.55876 14.4188 10.1768C14.3604 10.7982 14.2302 11.4108 14.031 12.0023C13.7581 11.5056 13.6169 10.9474 13.6208 10.3808L13.6215 10.3785ZM10.1348 18.2655C9.40126 17.8268 11.673 16.476 12.0848 16.4325C12.0825 16.4333 10.9028 18.7245 10.1348 18.2655ZM19.425 15.6713C19.4175 15.5963 19.35 14.766 17.8725 14.8013C17.2567 14.7913 16.6411 14.8347 16.0328 14.931C15.4435 14.3373 14.936 13.6677 14.5238 12.9398C14.7835 12.1893 14.9406 11.4073 14.991 10.6148C14.9693 9.71476 14.754 9.19876 14.064 9.20626C13.374 9.21376 13.2735 9.81751 13.3643 10.716C13.4532 11.3198 13.6208 11.9093 13.863 12.4695C13.863 12.4695 13.5443 13.4618 13.1228 14.4488C12.7013 15.4358 12.4133 15.9533 12.4133 15.9533C11.6803 16.1919 10.9903 16.5464 10.3695 17.0033C9.75151 17.5785 9.50026 18.0203 9.82576 18.462C10.1063 18.843 11.088 18.9293 11.9655 17.7795C12.4318 17.1857 12.8577 16.5613 13.2405 15.9105C13.2405 15.9105 14.5785 15.5438 14.9948 15.4433C15.411 15.3428 15.9143 15.2633 15.9143 15.2633C15.9143 15.2633 17.136 16.4925 18.3143 16.449C19.4925 16.4055 19.4355 15.7448 19.428 15.6728"
								fill="#DD2025"
							/>
							<path
								d="M17.9655 1.55774V5.96249H22.1902L17.9655 1.55774Z"
								fill="#909090"
							/>
							<path
								d="M18.0232 1.5V5.90475H22.2479L18.0232 1.5Z"
								fill="#F4F4F4"
							/>
							<path
								d="M6.73123 3.34277H6.70873H6.55348H5.75098V6.94277H6.52498V5.72927L6.69598 5.73902C6.8614 5.73618 7.02528 5.70654 7.18123 5.65127C7.31794 5.60423 7.44372 5.52999 7.55098 5.43302C7.65928 5.34039 7.74453 5.22381 7.79998 5.09252C7.8752 4.8739 7.90207 4.64155 7.87873 4.41152C7.87404 4.2472 7.84523 4.08447 7.79323 3.92852C7.74588 3.81595 7.67562 3.71447 7.58691 3.63054C7.4982 3.54661 7.39299 3.48207 7.27798 3.44102C7.17808 3.40467 7.07482 3.37829 6.96973 3.36227C6.89055 3.35006 6.81059 3.34354 6.73048 3.34277M6.58873 5.06327H6.52198V3.95327H6.66748C6.73136 3.94867 6.79547 3.95847 6.85505 3.98197C6.91464 4.00547 6.96818 4.04205 7.01173 4.08902C7.10197 4.20978 7.15017 4.35678 7.14898 4.50752C7.14898 4.69202 7.14898 4.85927 6.98248 4.97702C6.86253 5.043 6.72599 5.0727 6.58948 5.06252"
								fill="white"
							/>
							<path
								d="M9.342 3.33303C9.25875 3.33303 9.17775 3.33903 9.12075 3.34128L8.9445 3.34578H8.3595V6.94578H9.048C9.31112 6.95299 9.57309 6.90839 9.819 6.81453C10.0169 6.73602 10.1922 6.60946 10.329 6.44628C10.462 6.28162 10.5575 6.08991 10.6087 5.88453C10.6677 5.65193 10.6964 5.41271 10.6942 5.17278C10.7088 4.8894 10.6869 4.60532 10.629 4.32753C10.5741 4.12305 10.4712 3.9346 10.329 3.77778C10.2174 3.65115 10.0808 3.549 9.92775 3.47778C9.79633 3.41696 9.65809 3.37214 9.516 3.34428C9.45949 3.33494 9.40226 3.33068 9.345 3.33153M9.2085 6.28428H9.1335V3.98628H9.14325C9.29787 3.96849 9.45431 3.99639 9.59325 4.06653C9.69499 4.14777 9.7779 4.25013 9.83625 4.36653C9.89921 4.48903 9.93551 4.62348 9.94275 4.76103C9.9495 4.92603 9.94275 5.06103 9.94275 5.17278C9.9458 5.3015 9.93752 5.43025 9.918 5.55753C9.89488 5.6882 9.85215 5.81463 9.79125 5.93253C9.72232 6.04214 9.62918 6.13451 9.519 6.20253C9.42646 6.26238 9.31689 6.2903 9.207 6.28203"
								fill="white"
							/>
							<path
								d="M13.0148 3.34576H11.1923V6.94576H11.9633V5.51776H12.9383V4.84876H11.9633V4.01476H13.0133V3.34576"
								fill="white"
							/>
						</svg>
					</a>
				) : (
					"-"
				)}
			</td>
			<td>
				<Badge
					className="text-capitalize"
					variant={`${
						item.status === "active"
							? "success"
							: item.status === "inactive"
							? "danger"
							: item.status === "vacation"
							? "warning"
							: "info"
					} light`}>
					{Translate[lang][item?.status]}
				</Badge>
			</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{canEdit("admin") && (
						<img
							src={editIcon}
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
					{canDelete("admin") && (
						<img
							src={trashIcon}
							onClick={() => setDeleteModal(true)}
							className="cursor-pointer"
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.name}
					deletedItem={item}
					modelService={adminService}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
		</tr>
	);
};
export default CardItem;
